import { create, StateCreator } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface Column {
  id: string;
  title: string;
  settings_str: string;
  type: string;
}

interface ColumnValue {
  id: string;
  text: string;
  value: string;
  type: string;
  title: string;
  formattedValue?: string;
  column: {
    id: string;
    title: string;
    settings_str: string;
  };
}

interface SubItem {
  id: string;
  name: string;
  board: {
    columns: Column[];
  };
  column_values: ColumnValue[];
}

interface MondayStoreState {
  subitems: SubItem[];

  setSubItems: (subitems: SubItem[]) => void;
  resetSubitems: () => void;
}

type MondayStoreCreator = StateCreator<
  MondayStoreState,
  [['zustand/immer', never]],
  [],
  MondayStoreState
>;

const createMondayStore: MondayStoreCreator = (set) => ({
  subitems: [],

  setSubItems: (subitems: SubItem[]) =>
    set((draft) => {
      draft.subitems = subitems;
    }),
  resetSubitems: () =>
    set((draft) => {
      draft.subitems = [];
    }),
});

export const useMondayStore = create<MondayStoreState>()(
  devtools(immer(createMondayStore), {
    name: 'monday-store',
    enabled: process.env.NODE_ENV === 'development',
  }),
);
